import React, { useContext } from "react";
import { MyContext } from "../../context/MyContext";
import { RxCross2 } from "react-icons/rx";

const WithdrawAmount = () => {
  const { showWithdrawAmountPopUp, setShowWithdrawAmountPopUp } =
    useContext(MyContext);
  return (
    <section className="fixed  min-w-xl inset-0 bg-black bg-opacity-50 flex  justify-center items-center z-50 ">
      <div className="bg-white max-h-[600px] p-5 flex flex-col items-center gap-2">
        <div className="flex justify-between items-center w-full">
          <p className=""> WIthdrawAmount</p>
          <RxCross2
            className="text-3xl cursor-pointer"
            onClick={() => setShowWithdrawAmountPopUp(false)}
          />
        </div>
        <div className="overflow-x-auto">
          <table className="border-2 border-purple-600 w-full sm:w-sm md:w-md lg:w-lg ">
            <thead>
              <tr>
                <th className="border-2 border-purple-500 px-1 py-1 text-purple-500">
                  Sl No.
                </th>
                <th className="border-2 border-purple-500 px-1 py-1 text-purple-500">
                  Account Holder Name
                </th>
                <th className="border-2 border-purple-500 px-1 py-1 text-purple-500">
                  Bank Name
                </th>
                <th className="border-2 border-purple-500 px-1 py-1 text-purple-500">
                  Account Number
                </th>
                <th className="border-2 border-purple-500 px-1 py-1 text-purple-500">
                  IFSC Code
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="text-center tex-xs">
                <td className="border-2 border-purple-500 px-1 py-1">
                  {"Sno" || "1"}
                </td>
                <td className="border-2 border-purple-500 px-1 py-1">
                  {"SIddhant"}
                </td>
                <td className="border-2 border-purple-500 px-1 py-1">
                  {"Union Bank Of India"}
                </td>
                <td className="border-2 border-purple-500 px-1 py-1">
                  {"786589764"}
                </td>
                <td className="border-2 border-purple-500 px-1 py-1">
                  {"likjhgfds"}
                </td>
              </tr>
            </tbody>
          </table>
          {/* //------------------------------------------------- */}
          <div className="flex justify-center items-center">
            <div className="border-2 mt-5 px-4 py-2 flex justify-between items-center w-1/2">
              <div>
                <h2>Amount</h2>
                <h2>Pension Charge (20%)</h2>
                <h2>TDS (10%)</h2>
                <h2>Service Charge(5%)</h2>
                Final Amount
              </div>

              <div>
                <p>100000</p>
                <p>2000</p>
                <p>1000</p>
                <p>1000</p>
                <p>6000</p>
              </div>
            </div>
          </div>
        </div>

        <button className="bg-violet-500 text-white text-xl py-1 px-3 rounded-md ">Status</button>
      </div>
    </section>
  );
};

export default WithdrawAmount;
